'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_11bc8044 = {"text":"NotFound_module_text__eeb7b5b5"};
require("../../../assets/cjs/components/Table/src/NotFound~HLNhVJ1-.css");

exports.default = modules_11bc8044;
//# sourceMappingURL=NotFound.module.less.js.map
